import React from "react"
import { Box, Container } from "@mui/material"
import { styled } from "@mui/material/styles";

// PostList
export const PostListBox = styled(Box)(({ theme }) => ({
    paddingTop: '40px', background: theme.palette.primary.light, width: '100vw', height: '100vh'

}))



// AddNewPost
export const AddNewPostBox = styled(Box)(() => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: '99',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'

}))

export const AddNewPostContainer = styled(Container)(({ theme }) => ({
    backgroundColor: theme.palette.primary.light,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
    borderRadius: '20px'

}))